import { Injectable, signal } from '@angular/core';

export type AdminConfirmDialogOptions = {
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmVariant?: 'primary' | 'danger';
  commentRequired?: boolean;
};

export type AdminConfirmDialogState = AdminConfirmDialogOptions & {
  open: true;
  busy: boolean;
  error: string | null;
};

@Injectable({ providedIn: 'root' })
export class AdminConfirmDialogService {
  readonly state = signal<AdminConfirmDialogState | null>(null);

  private resolver: ((confirmed: boolean) => void) | null = null;

  confirm(options: AdminConfirmDialogOptions): Promise<boolean> {
    if (this.resolver) {
      return Promise.resolve(false);
    }

    return new Promise((resolve) => {
      this.resolver = resolve;
      this.state.set({
        open: true,
        title: options.title ?? 'Confirm',
        message: options.message,
        confirmLabel: options.confirmLabel ?? 'Confirm',
        cancelLabel: options.cancelLabel ?? 'Cancel',
        confirmVariant: options.confirmVariant ?? 'primary',
        commentRequired: options.commentRequired ?? false,
        busy: false,
        error: null,
      });
    });
  }

  setBusy(busy: boolean): void {
    const current = this.state();
    if (!current) return;
    this.state.set({ ...current, busy, error: busy ? null : current.error });
  }

  setError(message: string | null): void {
    const current = this.state();
    if (!current) return;
    this.state.set({ ...current, error: message, busy: false });
  }

  resolve(confirmed: boolean): void {
    this.resolver?.(confirmed);
    this.resolver = null;
    this.state.set(null);
  }
}
